import { MilestoneToBeBilled } from '@/services/billing/types/billing.type';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Box,
  Checkbox,
  Accordion,
  Typography,
  AccordionDetails,
  AccordionSummary,
  FormControlLabel,
} from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useBillingStore } from '../../store/billing.store';
import { formatYearMonth } from '../../utils/format-year-month.utils';
import { MilestoneAccordionItemList } from './milestone-accordion-item-list';

export interface MilestoneAccordionMonthListProps {
  groupedMilestones: { yearMonth: string; milestones: MilestoneToBeBilled[] };
}

export const MilestoneAccordionMonthList = ({
  groupedMilestones,
}: MilestoneAccordionMonthListProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  //Billing order store
  const selectAllMonth = useBillingStore((state: any) => state.selectAllMonth);
  const deselectAllMonth = useBillingStore((state: any) => state.deselectAllMonth);

  const isAllMonthSelected = useBillingStore((state: any) => {
    const selectedIds = new Set(state.selectedMilestones.map((milestone: any) => milestone._id));
    return groupedMilestones.milestones.every((milestone) => selectedIds.has(milestone._id));
  });

  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    milestones: MilestoneToBeBilled[]
  ) => {
    if (event.target.checked) {
      selectAllMonth(milestones);
    } else {
      deselectAllMonth(milestones);
    }
  };

  return (
    <Accordion
      disableGutters
      sx={{
        mb: 3,
        boxShadow: 'none',
        borderRadius: 1,
        backgroundColor: theme.palette.background.neutral,
        border: `1px solid ${alpha(theme.palette.grey[500], 0.12)}`,
        '&:before': { display: 'none' },
        '&.Mui-expanded': {
          backgroundColor: theme.palette.background.neutral,
        },
      }}
    >
      <AccordionSummary
        id={`panel-${groupedMilestones.yearMonth}`}
        aria-controls={`panel-${groupedMilestones.yearMonth}`}
        expandIcon={<ExpandMoreIcon />}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <FormControlLabel
            aria-label={`${groupedMilestones.yearMonth} month selector}`}
            label={
              <Typography variant="h6" fontWeight="bold">
                {t(formatYearMonth(groupedMilestones.yearMonth))}
              </Typography>
            }
            control={
              <Checkbox
                checked={isAllMonthSelected}
                onChange={(e) => handleCheckboxChange(e, groupedMilestones.milestones)}
              />
            }
            onClick={(e) => e.stopPropagation()}
          />
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <MilestoneAccordionItemList milestones={groupedMilestones.milestones} />
      </AccordionDetails>
    </Accordion>
  );
};
